module.exports = "<tf-company-news-indicator model=\"ctrl.latestNewsItem$ | async : this\">\n\n</tf-company-news-indicator>";